module.exports = __webpack_public_path__ + "static/RecruitNewGraduate-b46b3ba9f2869837a7ee35797223dd71.png";